import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react';
import { runInAction } from 'mobx';

import { showDebugInfo } from '../Helper/Debug';

@observer
export class DebugFragment extends React.Component {
    public override render(): React.ReactNode {
        if (!showDebugInfo.get()) {
            return null;
        }

        return (
            <React.Fragment>
                <Typography>&nbsp;</Typography>
                <IconButton onClick={this.hide} size="large"><CloseIcon/></IconButton>
                {this.props.children}
            </React.Fragment>
        );
    }

    protected hide = (): void => {
        runInAction(() => { showDebugInfo.set(false); });
    };
}